/**
 * An object containing a collection of cities organized by their corresponding provinces.
 * Each province key contains another object where the keys are the city names in kebab-case and
 * the values are the human-readable city names.
 *
 * @type {Object<string, Object<string, string>>}
 */
export const cities = {
  dolnoslaskie: {
    'jelenia-gora': 'Jelenia Góra',
    legnica: 'Legnica',
    lubin: 'Lubin',
    glogow: 'Głogów',
    walbrzych: 'Wałbrzych',
    wroclaw: 'Wrocław'
  },
  lodzkie: {
    'aleksandrow-lodzki': 'Aleksandrów Łódzki',
    lodz: 'Łódź',
    lowicz: 'Łowicz',
    'piotrkow-trybunalski': 'Piotrków Trybunalski',
    skierniewice: 'Skierniewice'
  },
  lubelskie: {
    chelm: 'Chełm',
    lublin: 'Lublin',
    zamosc: 'Zamość'
  },
  lubuskie: {
    'gorzow-wielkopolski': 'Gorzów Wielkopolski',
    'zielona-gora': 'Zielona Góra'
  },
  malopolskie: {
    krakow: 'Kraków',
    'nowy-sacz': 'Nowy Sącz',
    'nowy-targ': 'Nowy Targ',
    'stary-sacz': 'Stary Sącz',
    tarnow: 'Tarnów',
    zakopane: 'Zakopane',
    wieliczka: 'Wieliczka'
  },
  mazowieckie: {
    garwolin: 'Garwolin',
    'grodzisk-mazowiecki': 'Grodzisk Mazowiecki',
    grojec: 'Grójec',
    jozefow: 'Józefów',
    'konstancin-jeziorna': 'Konstancin-Jeziorna',
    lomianki: 'Łomianki',
    legionowo: 'Legionowo',
    'minsk-mazowiecki': 'Mińsk Mazowiecki',
    otwock: 'Otwock',
    piaseczno: 'Piaseczno',
    piastow: 'Piastów',
    plock: 'Płock',
    pruszkow: 'Pruszków',
    radom: 'Radom',
    siedlce: 'Siedlce',
    sochaczew: 'Sochaczew',
    sulejowek: 'Sulejówek',
    warszawa: 'Warszawa',
    wolomin: 'Wołomin',
    zyrardow: 'Żyrardów'
  },
  opolskie: {
    opole: 'Opole',
    'kedzierzyn-kozle': 'Kędzierzyn Koźle'
  },
  podkarpackie: {
    rzeszow: 'Rzeszów',
    przemysl: 'Przemyśl',
    'stalowa-wola': 'Stalowa Wola'
  },
  podlaskie: {
    bialystok: 'Białystok',
    lomza: 'Łomża',
    suwalki: 'Suwałki'
  },
  pomorskie: {
    gdansk: 'Gdansk',
    gdynia: 'Gdynia',
    hel: 'Hel',
    'krynica-morska': 'Krynica Morska',
    leba: 'Łeba',
    reda: 'Reda',
    rumia: 'Rumia',
    slupsk: 'Słupsk',
    sopot: 'Sopot',
    ustka: 'Ustka',
    wejherowo: 'Wejherowo',
    wladyslawowo: 'Władysławowo'
  },
  slaskie: {
    bytom: 'Bytom',
    'bielsko-biala': 'Bielsko-Biała',
    chorzow: 'Chorzów',
    czestochowa: 'Częstochowa',
    'dabrowa-gornicza': 'Dąbrowa Górnicza',
    gliwice: 'Gliwice',
    katowice: 'Katowice',
    myslowice: 'Mysłowice',
    'piekary-slaskie': 'Piekary Śląskie',
    sosnowiec: 'Sosnowiec',
    'ruda-slaska': 'Ruda Śląska',
    rybnik: 'Rybnik',
    szczyrk: 'Szczyrk',
    'tarnowskie-gory': 'Tarnowskie Góry',
    tychy: 'Tychy',
    ustron: 'Ustroń',
    wisla: 'Wisła',
    zabrze: 'Zabrze',
    zywiec: 'Żywiec'
  },
  swietokrzyskie: {
    kielce: 'Kielce',
    starachowice: 'Starchowice'
  },
  'warminsko-mazurskie': {
    elblag: 'Elbląg',
    olsztyn: 'Olsztyn'
  },
  wielkopolskie: {
    kalisz: 'Kalisz',
    konin: 'Konin',
    poznan: 'Poznań'
  },
  zachodniopomorskie: {
    koszalin: 'Koszalin',
    kolobrzeg: 'Kołobrzeg',
    stargard: 'Stargard',
    szczecin: 'Szczecin'
  }
};
